export default __webpack_public_path__ + "620e2adc6ec2afe7667d321348925ebc.png";